import { TmWorkerError } from '@/core/error/worker/TmWorkerError'

export class TmPdfWorkerError extends TmWorkerError {
  public name = 'TmPdfWorkerError'
}
